import { createSlice } from "@reduxjs/toolkit";
import i18n from '../i18n';

const initialState = {
    selectedLanguage: i18n.language || 'en', // Get default language
  };

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      i18n.changeLanguage(action.payload); // Change i18n language
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
